<template>
  <section ref="anchor" class="faq">
    <div class="font-60-68-bold faq__title">{{ content.title }}</div>

    <div class="faq__content">
      <div class="faq__list">
        <div
          v-for="item in content.content"
          :key="item.id"
          class="faq__item"
          :class="{ 'faq__item--active': activeId === item.id }"
          @click="toggleItem(item.id)"
        >
          <div class="faq__item-header">
            <div class="font-18-24 faq__item-title">
              {{ item.title }}
            </div>

            <div class="faq__item-arrow">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 9L12 15L18 9"
                  stroke="#212832"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <transition
            name="faq-fade"
            @enter="startTransition"
            @after-enter="endTransition"
            @before-leave="startTransition"
            @after-leave="endTransition"
          >
            <div v-show="activeId === item.id" class="faq__item-content">
              <div class="font-18-24 faq__item-description">
                {{ item.description }}
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { electronicFAQData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicFAQ',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicFAQData,
      activeId: null,
    }
  },
  methods: {
    openItem(id) {
      this.activeId = id
      const menuHeight = this.$store.getters.getOffsets.HeaderComponent
      const offset = this.$refs.anchor.offsetTop - menuHeight
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    },
    toggleItem(id) {
      this.activeId = this.activeId === id ? null : id
    },
    startTransition(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition(el) {
      el.style.height = ''
    },
  },
}
</script>

<style lang="sass" scoped>
.faq
  &__content
    padding: 0 $desktopHorizontalPaddings 0
    margin-bottom: 8rem
    border-top: 1px solid $backgroundGray
    border-bottom: 1px solid $backgroundGray
    @media (max-width: 1279px)
      padding: 0 $mobileHorizontalPaddings 0
      margin-bottom: 4rem
  &__title
    padding: 0 $desktopHorizontalPaddings
    margin-bottom: 4rem
    @media (max-width: 1279px)
      padding: 0 $mobileHorizontalPaddings
    @media (max-width: 1023px)
      margin-bottom: 3.2rem

  &__list
    border-left: 1px solid $backgroundGray
    border-right: 1px solid $backgroundGray
    border-bottom: none

  &__item
    border-bottom: 1px solid $backgroundGray
    cursor: pointer
    padding: 2rem
    &:last-child
      border-bottom: none
    &-header
      display: flex
      justify-content: space-between
      align-items: center
      gap: 2rem

    &-title
      flex: 1
      font-weight: 500
      color: $textPrimary

    &-arrow
      transition: transform 0.3s ease
      display: flex
      align-items: center
      justify-content: center
      svg
        width: 2.4rem
        height: 2.4rem

    &--active
      .faq__item-arrow
        transform: rotate(180deg)

    &-content
      overflow: hidden
      transition: height 0.3s ease

    &-description
      padding-top: 2rem
      color: $textSecondary
      @media (max-width: 1023px)
        padding-bottom: 2rem

.faq-fade-enter-active,
.faq-fade-leave-active
  transition: height 0.3s ease, opacity 0.3s ease

.faq-fade-enter,
.faq-fade-leave-to
  height: 0 !important
  opacity: 0
</style>
